import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import ReportProblemModal from './ReportProblemModal';

/** Pages avec barre d’actions en bas à droite (Continuer / Choisir) — remonter le FAB. */
function hasBottomRightAction(pathname: string): boolean {
    return (
        pathname.startsWith('/creer-lettre') ||
        pathname.startsWith('/choix-modele-lettre') ||
        pathname.startsWith('/lettre/')
    );
}

/** Bulle flottante « Signaler un problème » — visible uniquement connecté (hors admin). */
const ReportProblemFab: React.FC = () => {
    const { isAuthenticated, isAdmin } = useAuth();
    const { pathname } = useLocation();
    const [open, setOpen] = useState(false);

    if (!isAuthenticated || isAdmin) return null;

    const lift = hasBottomRightAction(pathname);

    return (
        <>
            <button
                type="button"
                data-tour="report"
                onClick={() => setOpen(true)}
                className={`no-print fixed right-5 z-[70] flex items-center gap-2 rounded-full bg-amber-500 hover:bg-amber-600 text-white shadow-lg shadow-amber-500/30 px-4 py-3 font-bold text-sm transition-transform hover:scale-105 active:scale-95 ${
                    lift ? 'bottom-24' : 'bottom-5'
                }`}
                aria-label="Signaler un problème"
            >
                <span className="flex h-8 w-8 items-center justify-center rounded-full bg-white/20">
                    <AlertTriangle className="w-4 h-4" />
                </span>
                <span className="pr-1 hidden sm:inline">Signaler un problème</span>
            </button>
            <ReportProblemModal open={open} onClose={() => setOpen(false)} />
        </>
    );
};

export default ReportProblemFab;
